/**
 * @generated SignedSource<<9eb3c88bef8f92e2541b6393844a7505>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraIssueDeploymentEnvironmentState = "DEPLOYED" | "NOT_DEPLOYED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference$data = ReadonlyArray<{
  readonly node: {
    readonly devOpsSummarisedEntities?: {
      readonly summarisedBuilds: {
        readonly count: number | null | undefined;
      } | null | undefined;
      readonly summarisedDeployments: {
        readonly count: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly devSummaryCache?: {
      readonly devSummary: {
        readonly branch: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly build: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly commit: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly deploymentEnvironments: {
          readonly overall: {
            readonly topEnvironments: ReadonlyArray<{
              readonly status: JiraIssueDeploymentEnvironmentState | null | undefined;
            }> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly pullrequest: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly review: {
          readonly overall: {
            readonly count: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly summarisedBuilds?: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly summarisedDeployments?: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"issueCard_softwareReleasesVersionDetailIssueList_jiraIssue">;
  };
  readonly " $fragmentType": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference";
}>;
export type issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference$key = ReadonlyArray<{
  readonly " $data"?: issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference$data;
  readonly " $fragmentSpreads": FragmentRefs<"issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v1 = [
  {
    "concreteType": "DevOpsSummarisedDeployments",
    "kind": "LinkedField",
    "name": "summarisedDeployments",
    "plural": false,
    "selections": (v0/*: any*/)
  },
  {
    "concreteType": "DevOpsSummarisedBuilds",
    "kind": "LinkedField",
    "name": "summarisedBuilds",
    "plural": false,
    "selections": (v0/*: any*/)
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    },
    {
      "kind": "RootArgument",
      "name": "shouldIncludeDevOpsFieldsViaAgs"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "node.key"
          },
          {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "concreteType": "DevOpsSummarisedEntities",
                "kind": "LinkedField",
                "name": "devOpsSummarisedEntities",
                "plural": false,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "JiraIssueDevSummaryResult",
                "kind": "LinkedField",
                "name": "devSummaryCache",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueDevSummary",
                    "kind": "LinkedField",
                    "name": "devSummary",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "pullrequest",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssuePullRequestDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": (v0/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "branch",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueBranchDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": (v0/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "review",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueReviewDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": (v0/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "commit",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueCommitDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": (v0/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "build",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueBuildDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": (v0/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                        "kind": "LinkedField",
                        "name": "deploymentEnvironments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueDeploymentEnvironment",
                                "kind": "LinkedField",
                                "name": "topEnvironments",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "status"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldIncludeDevOpsFieldsViaAgs",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v1/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue"
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    }
  ],
  "type": "JiraIssueEdge"
};
})();

(node as any).hash = "9f22d41da8c51a4ad6a88b9583ed10fd";

export default node;
